import { Component } from "@angular/core";

@Component({
    selector: 'app-week-date-slider',
    templateUrl: './week-date-slider.component.html',
    styleUrls: ['./week-date-slider.component.scss']
})

export class WeekDateSlider {
    

}